export const fr = {
  referralPage: {
    meta: {
      title:
        'Logiciel inspiré et événements de bénévolat entièrement coordonnés',
    },
    header: {
      title: 'Programme de parrainage Purposely',
      subtitle:
        "Vous recevez 1000$ et votre ami obtient 10% de réduction lorsqu'il choisit Purposely",
    },
    howItWorks: {
      title: 'Comment ça marche',
      options: {
        sendEmail: {
          title: 'Envoyez un e-mail',
          subtitle:
            "Remplissez le formulaire ci-dessous et envoyez un e-mail d'introduction aux clients potentiels. Assurez-vous de mettre eric@purposely.co en copie et nous prendrons le relais!",
        },
        friendGetsMessage: {
          title: 'Votre ami reçoit le message',
          subtitle:
            "Nous répondrons à l'e-mail, et si le client référé conclut l'affaire, vous serez éligible pour la récompense de parrainage.",
        },
        getRewarded: {
          title: 'Soyez récompensé',
          subtitle:
            'Pour chaque parrainage réussi, vous recevrez 1000$ en guise de remerciement de notre part!',
        },
      },
    },
    template: {
      title: 'Copiez et collez notre modèle pour faciliter les choses',
      greeting: "Bonjour [Nom de l'ami],",
      paragraph1:
        "J'espère que vous allez bien! Je voulais vous contacter au cas où votre entreprise explorerait des moyens de rendre l'engagement des employés plus impactant grâce au bénévolat. Pourriez-vous transmettre ce message à votre VP Ressources Humaines ou VP Expérience Employé pour en savoir plus sur Purposely et l'envisager pour votre organisation?",
      paragraph2:
        'Voici un bref résumé que vous pouvez transmettre à toute personne qui pourrait être intéressée:',
      paragraph3:
        "Purposely aide les entreprises à gérer des programmes de bénévolat structurés et à fort impact sans les maux de tête habituels de coordination. Il est conçu pour que les équipes favorisent un véritable engagement grâce au bénévolat de groupe, tout en suivant la participation et l'impact en cours de route. Des entreprises comme Clio, Boston Dynamics et GreenShield l'utilisent déjà pour alimenter leurs programmes.",
      links: {
        title: 'Quelques liens utiles:',
        overview: 'Aperçu de Purposely',
        caseStudy: 'Étude de cas Clio',
      },
      copyButton: 'Copier le texte',
      alertSuccess: 'Modèle copié dans le presse-papiers!',
      alertError: 'Échec de la copie du texte. Veuillez réessayer.',
    },
    termsAndConditions: {
      title: 'Termes et conditions',
      effectiveDate: "Date d'entrée en vigueur: 1er mai 2025",
      terms: [
        "Les récompenses sont émises lorsqu'une organisation référée signe un contrat d'un an ou plus avec Purposely.",
        'Pour être admissibles, les parrainages doivent être initiés par une introduction par e-mail. Purposely peut mettre à jour ou mettre fin au programme de parrainage à tout moment sans préavis.',
        "En cas de litige, Purposely déterminera les décisions finales d'admissibilité et de récompense.",
      ],
      contact:
        "Si vous avez des questions sur le programme de parrainage, n'hésitez pas à contacter Eric à eric@purposely.co.",
    },
  },
}
